import {Link} from 'lib/ui/link';
import computed from 'lib/mobx/computed';

export class CategoryLink extends Link {
    @computed get threadCount() {
        return this.category.threadCount;
    }

    @computed get newThreadCount() {
        return this.category.newThreadCount;
    }

    constructor(options) {
        const {category} = options;

        super({
            label: category.name,
            href: category.href,
        });

        this.category = category;
    }
}
